import { render, staticRenderFns } from "./MarketList.vue?vue&type=template&id=61796d9a&scoped=true"
import script from "./MarketList.vue?vue&type=script&lang=js"
export * from "./MarketList.vue?vue&type=script&lang=js"
import style0 from "./MarketList.vue?vue&type=style&index=0&id=61796d9a&prod&scoped=true&lang=css"
import style1 from "./MarketList.vue?vue&type=style&index=1&id=61796d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61796d9a",
  null
  
)

export default component.exports